import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { FiUser, FiTruck, FiUserCheck, FiStar } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import styles from './Stats.module.css';

export default function Stats() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  const stats = [
    { icon: <FiUser size={28}/>, end: 5, suffix: '+', label: t('stats.yearsExp') },
    { icon: <FiTruck size={28}/>, end: 225, suffix: '+', label: t('stats.oilDone') },
    { icon: <FiUserCheck size={28}/>, end: 1, suffix: '', label: t('stats.techician') },
    { icon: <FiStar size={28}/>, end: 100, suffix: '%', label: t('stats.satisfaction') },
  ];

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        {stats.map((s, i) => (
          <motion.div key={s.label} className={styles.item}
            initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: i * 0.1 }}>
            <div className={styles.icon}>{s.icon}</div>
            <div className={styles.num}>
              {inView ? <CountUp end={s.end} duration={2.2} suffix={s.suffix} /> : `0${s.suffix}`}
            </div>
            <div className={styles.label}>{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
